// 运营管理
export default [
  {
    path: '/postManagement/postManagement',
    name: 'postManagement',
    meta: {
      title: '回收点管理'
    },
    component: () => import('@/views/postManagement/postManagement.vue')
  },
  {
    path: '/postManagement/add',
    name: 'postManagement',
    meta: {
      title: '添加回收点管理'
    },
    component: () => import('@/views/postManagement/add.vue')
  },
  {
    path: '/postManagement/trademark',
    name: 'trademark',
    meta: {
      title: '商品类型列表'
    },
    component: () => import('@/views/postManagement/trademark.vue')
  },
  {
    path: '/postManagement/trademarkAdd',
    name: 'trademarkAdd',
    meta: {
      title: '添加商品类型列表'
    },
    component: () => import('@/views/postManagement/trademarkAdd.vue')
  },
  {
    path: '/postManagement/postBrand',
    name: 'postBrand',
    meta: {
      title: '品牌列表'
    },
    component: () => import('@/views/postManagement/postBrand.vue')
  },
  {
    path: '/postManagement/postBrandadd',
    name: 'postBrandadd',
    meta: {
      title: '添加品牌列表'
    },
    component: () => import('@/views/postManagement/postBrandadd.vue')
  },
  {
    path: '/postManagement/postGoodsManagement',
    name: 'postGoodsManagement',
    meta: {
      title: '商品管理'
    },
    component: () => import('@/views/postManagement/postGoodsManagement.vue')
  },
  {
    path: '/postManagement/recyclingPointManagement',
    name: 'recyclingPointManagement',
    meta: {
      title: '回收点管理'
    },
    component: () => import('@/views/postManagement/recyclingPointManagement.vue')
  },
  {
    path: '/postManagement/addPoint',
    name: 'addPoint',
    meta: {
      title: '回收点详情'
    },
    component: () => import('@/views/postManagement/addPoint.vue')
  },
  {
    path: '/postManagement/storeManagement',
    name: 'storeManagement',
    meta: {
      title: '商店管理'
    },
    component: () => import('@/views/postManagement/storeManagement.vue')
  },
  {
    path: '/postManagement/addStore',
    name: 'addStore',
    meta: {
      title: '添加循环商店'
    },
    component: () => import('@/views/postManagement/addStore.vue')
  }

]
